export const emptyGeneralTraveler = {
  formFields: {
    genderType: "",
    firstName: "",
    middleName: "",
    lastName: "",
    dateOfBirth: "",
    mealRequest: "",
  },
};

export const emptyStudentTraveler = {
  formFields: {
    hasStudentCard: "",
    discountCardNumber: "",
    cardExpiryDate: "",
    isFullTimeStudent: "",
    nameOfSchool: "",
    email: "",
    ...emptyGeneralTraveler.formFields,
  },
};

export const emptyYouthTraveler = {
  formFields: {
    hasYouthCard: "",
    discountCardNumber: "",
    cardExpiryDate: "",
    email: "",
    ...emptyGeneralTraveler.formFields,
  },
};
